import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import styles from "./Footer.module.css";

import { Linkedin, Twitter, Mail } from "lucide-react";

function Footer() {
  return (
    <>
      <footer className={`${styles.footerDiv} container-fluid py-5`}>
        <div className={`${styles.footerDivSmall} container w-50`}>
          <img
            src="/DataRevival_REV_RGB.svg"
            alt="PSDI Icon"
            className="img-fluid mb-3"
            style={{ width: "200px", height: "auto" }}
          />
          <small className="text-white">
            © 2025 DataRevival. All rights reserved.
          </small>
          <p className="text-white mt-4">
            Data revival is officially registered with Companies House in
            England and Wales, confirming our legal status and compliance with
            UK company regulations.
          </p>

          <div className="d-flex flex-row bd-highlight mb-3">
            <div>
              <a
                className="text-decoration-none text-white"
                href="https://x.com/malvox_cyber"
                target="_blank"
              >
                <Twitter className="me-3" />
              </a>
            </div>
            <div>
              <a
                className="text-decoration-none text-white"
                href="https://linkedin.com/company/malvox"
                target="_blank"
              >
                <Linkedin className="me-3" />
              </a>
            </div>
            <div>
              <a
                className="text-decoration-none text-white"
                href="https://medium.com/@malvox"
                target="_blank"
              >
                <Mail />
              </a>
            </div>
          </div>
          <div className="d-flex flex-column flex-md-row gap-2 w-100 mb-3">
            <Link
              className={`${styles.footerLink}`}
              rel="noopener noreferrer"
              to="termsOfService"
            >
              Terms of service
            </Link>
            <span className="d-none d-md-inline text-white">|</span>
            <Link
              className={`${styles.footerLink}`}
              rel="noopener noreferrer"
              to="/privacyPolicy"
            >
              Privacy policy
            </Link>
          </div>
        </div>
      </footer>
    </>
  );
}

export default Footer;
